<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="4">
                    <ValidationProvider name="company" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_company')">
                            <coop-company-selectbox v-model="formData.company_id" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="start_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('start_date')">
                            <SelectDate v-model="formData.start_date" :validation-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="end_date" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('end_date')">
                            <SelectDate v-model="formData.end_date" :validation-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="responsible_staff_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_posting_responsible')">
                            <staff-auto-complete v-model="formData.responsible_staff_id" return-value="id" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="min_gpa" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_min_gno')">
                            <b-form-input v-model="formData.min_gpa" type="number" step="0.01" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="position" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_position')">
                            <b-form-input v-model="formData.position" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="location_type" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_location_type')">
                            <parameter-selectbox v-model="formData.location_type"
                                                 code="coop_internship_posting.location_types"
                                                 :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="formData.status"
                                                 code="coop_internship_posting.statuses"
                                                 :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <ValidationProvider name="quota" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_quota')">
                            <b-form-input v-model="formData.quota" type="number" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="formData.faculty_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('department')">
                        <department-selectbox :faculty_code="formData.faculty_code" v-model="formData.department_code" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="4">
                    <b-form-group :label="$t('class')">
                        <classes-selectbox v-model="formData.class" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="content" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_posting_content')">
                            <b-form-textarea v-model="formData.content" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="company_intro" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_company_intro')">
                            <b-form-textarea v-model="formData.company_intro" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="benefits" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_provided_benefits')">
                            <b-form-textarea v-model="formData.benefits" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="requirements" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('coop_required_qualifications')">
                            <b-form-textarea v-model="formData.requirements" rows="4" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" class="mb-2"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" :disabled="formLoading" @click="update">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate'
    import FacultySelectbox from '@/components/interactive-fields/FacultySelectbox.vue';
    import DepartmentSelectbox from '@/components/interactive-fields/DepartmentSelectbox';
    import ClassesSelectbox from '@/components/interactive-fields/ClassesSelectbox';
    import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete';
    import ParameterSelectbox from '@/components/interactive-fields/ParameterSelectbox.vue';
    import CoopCompanySelectbox from '@/components/interactive-fields/CoopCompanySelectbox.vue';
    import SelectDate from '@/components/interactive-fields/SelectDate.vue';
    import CoopAdService from '@/services/CoopAdService';

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            FacultySelectbox,
            DepartmentSelectbox,
            ClassesSelectbox,
            StaffAutoComplete,
            ParameterSelectbox,
            CoopCompanySelectbox,
            SelectDate
        },
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    company_id: null,
                    position: null,
                    start_date: null,
                    end_date: null,
                    responsible_staff_id: null,
                    min_gpa: null,
                    location_type: null,
                    quota: null,
                    faculty_code: null,
                    department_code: null,
                    class: null,
                    status: 'active',
                    content: null,
                    company_intro: null,
                    benefits: null,
                    requirements: null
                }
            }
        },
        created() {
            this.get(this.formId);
        },
        methods: {
            get(id) {
                CoopAdService.get(id)
                    .then(response => {
                        const data = response.data.data || response.data;
                        this.formData = {
                            company_id: data.company_id || null,
                            position: data.position || '',
                            start_date: data.start_date || null,
                            end_date: data.end_date || null,
                            responsible_staff_id: data.responsible_staff_id || data.responsible_id || null,
                            min_gpa: data.min_gpa ?? data.min_gno ?? null,
                            location_type: data.location_type || null,
                            quota: data.quota || null,
                            faculty_code: data.faculty_code || null,
                            department_code: data.department_code || null,
                            class: data.class || null,
                            status: data.status || 'active',
                            content: data.content || '',
                            company_intro: data.company_intro || data.company_description || '',
                            benefits: data.benefits || '',
                            requirements: data.requirements || data.qualifications || ''
                        };
                    })
                    .catch((error) => {
                        this.showErrors(error, null);
                    });
            },
            async update() {
                const isValid = await this.$refs.formModalValidate.validate();

                if (isValid) {
                    this.formLoading = true;

                    CoopAdService.update(this.formId, this.formData)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.$emit('updateFormSuccess', true);
                        })
                        .catch((error) => {
                            this.showErrors(error, this.$refs.formModalValidate);
                        })
                        .finally(() => {
                            this.formLoading = false;
                        });
                }
            }
        }
    }
</script>
